import React, { useId } from "react";

const DutchFlag = () => (
  <svg viewBox="0 0 60 40" className="w-full h-full">
    <rect width="60" height="40" fill="#21468B" />
    <rect width="60" height="26.67" fill="#FFFFFF" />
    <rect width="60" height="13.33" fill="#AE1C28" />
  </svg>
);

const BritishFlag = () => {
  const clipId = useId();
  return (
    <svg viewBox="0 0 60 40" className="w-full h-full">
      <clipPath id={clipId}>
        <rect width="60" height="40" />
      </clipPath>
      <g clipPath={`url(#${clipId})`}>
        <rect width="60" height="40" fill="#012169" />
        <path d="M0,0 L60,40 M60,0 L0,40" stroke="#FFFFFF" strokeWidth="8" />
        <path d="M0,0 L60,40 M60,0 L0,40" stroke="#C8102E" strokeWidth="5" />
        <path d="M30,0 V40 M0,20 H60" stroke="#FFFFFF" strokeWidth="13" />
        <path d="M30,0 V40 M0,20 H60" stroke="#C8102E" strokeWidth="8" />
      </g>
    </svg>
  );
};

const FLAGS = { nl: DutchFlag, en: BritishFlag };

const LanguageFlag = ({ language, className = "" }) => {
  const Flag = FLAGS[language];
  if (!Flag) return null;
  return (
    <span className={`inline-flex w-[21px] h-[14px] rounded-[3px] overflow-hidden ring-1 ring-black/10 shrink-0 ${className}`} aria-hidden>
      <Flag />
    </span>
  );
};

export default LanguageFlag;
